var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5C9.04 5 5 9.04 5 14C5 18.96 9.04 23 14 23H23V17.64H14V12.64H28V28H14C6.28 28 2.98023e-08 21.72 2.98023e-08 14C2.98023e-08 6.28 6.28 -1.90735e-06 14 -1.90735e-06H28V5H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGW);
export default __webpack_public_path__ + "static/media/G-W.9796ba3cb28fdb1ac8149db3e648dc46.svg";
export { ForwardRef as ReactComponent };